import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { LegalPage } from '../../Common/HelpCenter';
import { PRIVACY_TITLE, PRIVACY_SECTIONS } from './legalContent';

const CLSFIPrivacyPolicy = () => (
  <LegalPage
    brand="CLS"
    header={<Header showTopBar={false} />}
    footer={<Footer />}
    title={PRIVACY_TITLE}
    sections={PRIVACY_SECTIONS}
  />
);

export default CLSFIPrivacyPolicy;
